// Site Configuration File
// This file contains all configurable elements for easy maintenance

/*
==================================================================================
                                    INDEX
==================================================================================

1.  BRAND INFORMATION...........................................(Line ~27)
2.  TYPOGRAPHY......................................................(Line ~35)
3.  COLOR PALETTE...................................................(Line ~49)
4.  IMAGES..........................................................(Line ~65)
5.  NAVIGATION MENU.................................................(Line ~80)
6.  CONTACT INFORMATION.............................................(Line ~106)
7.  NEWSLETTER......................................................(Line ~134)
8.  NEWSLETTER BANNER SECTION.......................................(Line ~141)
9.  NEWSLETTER MODAL CONFIGURATION..................................(Line ~156)
10. CALL TO ACTION SECTION..........................................(Line ~210)
11. HERO SECTION CONFIGURATION......................................(Line ~222)
12. ABOUT PAGE CONFIGURATION........................................(Line ~238)
13. PARTNERS PAGE CONFIGURATION.....................................(Line ~329)
14. ALEXANDER V. KAMMEL BIOGRAPHY PAGE CONFIGURATION................(Line ~378)
15. FILM + VIDEO MAGAZINE PAGE CONFIGURATION........................(Line ~425)
16. FILMSERVICE HISTORY PAGE CONFIGURATION..........................(Line ~486)
17. ÖSTERREICHISCHES FILMSERVICE PAGE CONFIGURATION.................(Line ~621)
18. FESTIVALS SECTION CONFIGURATION.................................(Line ~646)
19. FOOTER CONFIGURATION............................................(Line ~738)
20. SEO & META......................................................(Line ~790)

==================================================================================
*/

export const siteConfig = {
  // Brand Information
  brand: {
    name: "Filmservice",
    tagline: "Home of Corporate Film Festivals",
    logo: "/images/logos/FilmService_Logo.png"
  },

  // Typography
  typography: {
    fontFamily: {
      primary: "'Montserrat', sans-serif",           // For all text and almost everything
      scrolling: "'Bebas Neue', sans-serif",        // For every text that scrolls
      footer: "'Josefin Sans', sans-serif",          // For all text in footer (except contact us)
      fallback: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
    },
    googleFonts: {
      montserrat: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
      bebasNeue: "https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap",
      josefinSans: "https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap"
    }
  },

  // Color Palette
  colors: {
    primary: "#E63E96",      // Pink/Magenta
    primaryDark: "#B91C7C",  // Darker Pink for gradients
    secondary: "#202020",    // Dark Gray
    white: "#ffffff",
    black: "#000000",
    background: "#202020",   // Header background
    text: {
      primary: "#ffffff",
      secondary: "#E63E96",
      dark: "#000000"
    }
  },

  // Images (using placeholders for now)
  images: {
    logo: {
      src: "/images/logos/FilmService_Logo.png",
      alt: "Filmservice International"
    },
    hero: {
      src: "https://placehold.co/1920x800/1597D6/FFFFFF?text=Hero+Image",
      alt: "Corporate Film Festival Hero Image"
    },
    placeholder: {
      src: "https://placehold.co/400x300/1597D6/FFFFFF?text=Placeholder",
      alt: "Placeholder Image"
    }
  },

  // Navigation Menu
  navigation: {
    items: [
      { 
        name: "HOME", 
        path: "/", 
        type: "link" 
      },
      { 
        name: "WHO WE ARE", 
        type: "section",
        hasSubmenu: true,
        submenu: [
          { name: "ABOUT", path: "/about" },
          { name: "PARTNERS", path: "/partners" },
          { name: "FILMSERVICE HISTORY", path: "/filmservice-history" },
          { name: "ALEXANDER KAMMEL", path: "/alexander-kammel-biography" }
        ]
      },
      {
        name: "NOMINATE A JUROR",
        path: "/nominate-jury",
        type: "link"
      },
      {
        name: "FILM + VIDEO",
        subtitle: "Magazine",
        path: "/film-video-magazine",
        type: "link"
      },
      { 
        name: "ÖSTERREICHISCHES", 
        subtitle: "Filmservice",
        path: "/osterreichisches-filmservice", 
        type: "link" 
      }
    ]
  },

  // Contact Information
  contact: {
    email: "info@filmserviceinternational.com",
    phone: "+43/1/505 53 37",
    address: {
      street: "Schaumburgergasse 18",
      city: "Vienna",
      state: "CA",
      zip: "90210",
      country: "USA"
    },
    social: {
        vimeo: {
            url: "https://vimeo.com/filmserviceinternational", 
            icon: "fab fa-vimeo-v",
            name: "Vimeo"
        },
        facebook: {
            url: "https://www.facebook.com/FilmserviceInternational",
            icon: "fa-brands fa-facebook",
            name: "Facebook"
        },
        linkedin: {
            url: "https://www.linkedin.com/company/filmservice-international",
            icon: "fa-brands fa-linkedin",
            name: "LinkedIn"
        }
    }
  },

  // Newsletter
  newsletter: {
    title: "Stay Updated",
    description: "Subscribe to our newsletter for the latest updates on film festivals and industry news.",
    placeholder: "Enter your email address"
  },

  // Newsletter Banner Section
  newsletterBanner: {
    title: "BE FIRST IN LINE",
    subtitle: "AWARDS INSIGHTS STRAIGHT TO YOUR INBOX!",
    buttonText: "SUBSCRIBE",
    buttonIcon: {
      src: "/images/icons/Email.png",
      alt: "Email icon"
    },
    backgroundColor: "#E63E96",
    textColor: "#ffffff",
    scrollingSpeed: {
      titleLine: 15,
      subtitleLine: 5
    }
  },

  // Newsletter Modal Configuration
  newsletterModal: {
    title: "STAY UP TO DATE WITH ALL THE NEWS",
    subtitle: "We'll keep you informed about submission deadlines, winners, the jury, the award ceremony and much more.",
    newsletters: [
      {
        id: "cannes",
        label: "Receive the latest Cannes Corporate Media & TV Awards news",
        campaignId: "nZd5",
        defaultChecked: false
      },
      {
        id: "usInternational", 
        label: "Receive the latest US International Awards news",
        campaignId: "5cowh",
        defaultChecked: false
      },
      {
        id: "wirtschaftsfilmtage",
        label: "Receive the latest Internationale Wirtschaftsfilmtage news",
        campaignId: "T0w4",
        defaultChecked: false
      },
      {
        id: "staatspreis",
        label: "Receive the latest Staatspreis Wirtschaftsfilm news",
        campaignId: "nrxJ",
        defaultChecked: false
      }
    ],
    // Hidden campaign that all subscribers automatically get added to
    hiddenCampaigns: [
      {
        id: "filmservice",
        campaignId: "n4aY",
        description: "Main Filmservice International campaign - automatically subscribed"
      }
    ],
    // Form validation settings
    validation: {
      requireAllFields: true,
      requireAtLeastOneNewsletter: true,
      messages: {
        emailRequired: "Email address is required",
        emailInvalid: "Please enter a valid email address",
        nameRequired: "Name is required",
        newsletterRequired: "Please select at least one newsletter to subscribe to"
      }
    }
  },

  // Call to Action Section
  callToAction: {
    title: "WE'RE EAGER TO RECEIVE",
    subtitle: "YOUR CREATIVE ENTRIES",
    buttonText: "SUBMIT YOUR WORK",
    buttonUrl: "https://www.filmservicesubmissiontool.com/login",
    backgroundImage: {
      src: "/images/Banner_SubmityourWork.png",
      alt: "Submit Your Work Background Image"
    }
  },

  // Hero Section Configuration
  hero: {
    firstLine: {
      text: "FILMSERVICE",
      speed: 10
    },
    secondLine: {
      text: "INTERNATIONAL", 
      speed: 5
    },
    tagline: {
      show: true,
      text: "WE HONOR THE WORLD'S FINEST CORPORATE MEDIA"
    },
    scrollingBanner: {
      text: "WE HONOR THE WORLD'S FINEST CORPORATE MEDIA",
      speed: 10, // pixels per second
      direction: "left" // left or right
    }
  },

  // About Page Configuration
  about: {
    title: {
      lines: [
        { text: "ABOUT", speed: 30 }
      ]
    },
    content: {
      description: "Filmservice International, with its headquarters in Vienna, Austria, is Europe’s biggest organizer of corporate film awards. Led by Alexander V. Kammel, Filmservice International organizes the Internationale Wirtschaftsfilmtage every two years in Vienna, as well as the Cannes Corporate Media & TV Awards in Cannes and the US International Awards in Los Angeles, once a year. Furthermore, Alexander V. Kammel is also co-founder and director of the International Committee of Tourism Film Festivals (CIFFT), president of the Austrian Archives for Corporate, Educational, and Cultural Audiovisual Media, and organizer of the Staatspreis Wirtschaftsfilm.",
      callToAction: "Let's take a closer look at all the Filmservice International awards:"
    },
    backgroundImage: {
      src: "https://placehold.co/1920x800/1597D6/FFFFFF?text=About+Background",
      alt: "About Filmservice International Background"
    },
    accordion: [
      {
        title: "CANNES CORPORATE MEDIA & TV AWARDS",
        description: "The Cannes Corporate Media & TV Awards annually honors the world's finest corporate films, online media productions, documentaries, and reports in one of the world's most important film centers: in Cannes, France. It is the only festival for corporate films taking place in Cannes, the city famously known for feature films and advertising productions. The festival was founded in 2010 by Filmservice International. Since then it has constantly grown, becoming one of the top festivals for corporate films worldwide. The winners are celebrated annually in Cannes during a glamorous black-tie awards ceremony.",
        bannerImage: {
          src: "/images/bannersfestivals/Cannes-Corporate-Media-&-Tv-Awards.png",
          alt: "Cannes Corporate Media & TV Awards Banner"
        },
        website: "www.cannescorporatemedia.com",
        websiteUrl: "https://www.cannescorporate.com",
        socialMedia: [
          { icon: "fab fa-facebook", url: "https://www.facebook.com/CannesCorporate" },
          { icon: "fab fa-linkedin", url: "https://www.linkedin.com/company/cannes-corporate-media-tv-awards" }
        ]
      },
      {
        title: "US INTERNATIONAL AWARDS",
        description: "The US International Awards are a global competition honoring the world's best corporate videos, online & social media productions, and documentaries. The awards have a rich background of over 50 years. Initially established in Chicago in 1967 as the US Industrial Film and Video Festival, the competition underwent a significant transformation in 2001 when Lee Gluckman Jr. became its new chairman and leader. The festival moved to Los Angeles and was renamed the US International Film & Video Festival. However, after Lee Gluckman Jr. passed away, it seemed like the end of one of the oldest festivals dedicated to corporate video. Fortunately, Filmservice International and Alexander Kammel decided to continue the excellent work and transformed it into the new US International Awards, keeping the legacy of the memorable competition alive.",
        bannerImage: {
          src: "/images/bannersfestivals/Us-International-Awards.png",
          alt: "US International Awards Banner"
        },
        website: "www.usinternationalawards.com",
        websiteUrl: "https://www.usinternationalawards.com",
        socialMedia: [
          { icon: "fab fa-facebook", url: "https://www.facebook.com/usinternationalawards" },
          { icon: "fab fa-instagram", url: "https://www.instagram.com/usinternationalawards/" },
          { icon: "fab fa-linkedin", url: "https://www.linkedin.com/company/usinternationalawards" }
        ]
      },
      {
        title: "INTERNATIONALE WIRTSCHAFTSFILMTAGE",
        description: "Every two years, the Internationale Wirtschaftsfilmtage honor the best productions from the corporate and business film industry in Vienna. Launched in 1962 with the aim of acknowledging the outstanding creativity of filmmakers in the German-speaking countries, the award can now look back on a sixty-year history, making it one of the oldest of its kind. Since then, the event has brought together representatives from business, industry, tourism, public bodies, the film industry, the agency scene, and the TV and media sector, offering them not only an excellent platform for dialog, but also the opportunity to enter their best audiovisual productions into competition for the prestigious Victoria Trophies and to be recognized as award winners on an international level.",
        bannerImage: {
          src: "/images/bannersfestivals/Internationale-Wirtschaftsfilmtage.png",
          alt: "Internationale Wirtschaftsfilmtage Banner"
        },
        website: "www.wirtschaftsfilmtage.com",
        websiteUrl: "https://www.wirtschaftsfilmtage.com/",
        socialMedia: [
          { icon: "fab fa-facebook", url: "https://www.facebook.com/Wirtschaftsfilmtage" },
          { icon: "fab fa-linkedin", url: "https://www.linkedin.com/company/internationale-wirtschaftsfilmtage/posts/?feedView=all" }
        ]
      },
      {
        title: "STAATSPREIS WIRTSCHAFTSFILM",
        description: "Österreichischer Staatspreis Wirtschaftsfilm has been awarded biennially to the best corporate films since 2005. The Austrian National Prize for corporate films is additionally organized by the Federal Ministry of Economy, Energy and Tourism in cooperation with the Austrian Federal Economic Chamber's professional association for the film and music industry. The aim of this State prize is both to provide an impetus for the business film sector and the Austrian film industry, and to underline the importance of Austrian corporate films, and give it a stronger media presence as well as a platform for networking and exchange.",
        bannerImage: {
          src: "/images/bannersfestivals/Staatspreis-Wirtschaftsfilm.png",
          alt: "Staatspreis Wirtschaftsfilm Banner"
        },
        website: "www.staatspreis.at",
        websiteUrl: "https://www.staatspreisfilm.at",
        socialMedia: [
          { icon: "fab fa-linkedin", url: "https://www.linkedin.com/company/staatspreis-wirtschaftsfilm" }
        ]
      },
      {
        title: "CIFFT CIRCUIT",
        description: "The International Committee of Tourism Film Festivals (CIFFT) brings together international corporate and tourism film awards at an exclusive competition for videos and campaigns, the CIFFT Circuit. The competition will define the World's Best Tourism Films of the year, based on the number of awards won and the position on the CIFFT Rankings. At the end of the CIFFT Circuit, the most effective tourism videos and the creative talents behind them are celebrated at the World Tourism Film Awards.",
        bannerImage: {
          src: "/images/bannersfestivals/CIFFT-Circuit.png",
          alt: "CIFFT Circuit Banner"
        },
        website: "www.cifft.com",
        websiteUrl: "https://www.cifft.com",
        socialMedia: [
          { icon: "fab fa-facebook", url: "https://www.facebook.com/cifft.circuit" },
          { icon: "fab fa-instagram", url: "https://www.instagram.com/cifft.circuit" },
          { icon: "fab fa-linkedin", url: "https://www.linkedin.com/company/cifft" },
          { icon: "fab fa-twitter", url: "https://x.com/cifft_circuit" },
          { icon: "fab fa-youtube", url: "https://www.youtube.com/channel/UCrkNW7bLAGWt8x0BDTc27nQ" }
        ]
      }
    ]
  },

  // Partners Page Configuration
  partners: {
    title: {
      lines: [
        { text: "PARTNERS", speed: 20 }
      ]
    },
    membersSection: {
      title: "WE ARE MEMBERS OF",
      logos: [
        {
          src: "/images/partners/IQ.png",
          alt: "iQ - Initiative for Quality Film Production"
        },
        {
          src: "/images/partners/IAA.png",
          alt: "IAA Austria - Interactive Advertising Bureau Austria"
        },
        {
          src: "/images/partners/PRVA.png",
          alt: "PRVA - Public Relations Association of Austria"
        },
        {
          src: "/images/partners/AHK.png",
          alt: "AHK - Austrian Chamber of Commerce"
        }
      ]
    },
    mediaPartnersSection: {
      title: "OUR MEDIA PARTNERS",
      logos: [
        {
          src: "/images/partners/BULB.png",
          alt: "BULB! Media Magazine"
        },
        {
          src: "/images/partners/SoyMarketing.png",
          alt: "sou.marketing"
        }
      ]
    }
  },

  // Alexander V. Kammel Biography Page Configuration
  alexanderKammelBiography: {
    title: {
      lines: [
        { text: "ALEXANDER V. KAMMEL", speed: 5 },
        { text: "BIOGRAPHY", speed: 20 }
      ]
    },
    content: {
      leftColumn: "Alexander V. Kammel is President and Owner of Filmservice International, Europe’s leading organizer of corporate film awards. He is the director of high-profile awards, including the Internationale Wirtschaftsfilmtage, the Cannes Corporate Media & TV Awards, the US International Awards, and the International Committee of Tourism Film Festivals (CIFFT). As founder of the Cannes Corporate Media & TV Awards in 2010, Alexander has established one of the world’s foremost platforms for corporate films and documentaries. He is also the co-founder and director of the World Tourism Film Awards, a prestigious event that recognizes the best in tourism promotion worldwide.",
      rightColumn: "In 2021, he further expanded Filmservice International’s global footprint by assuming leadership of the US International Awards and facilitating the launch of the AutoVision Awards in China, overseeing the festival’s strategic expansion into the Asian market. Alexander also organizes the Staatspreis Wirtschaftsfilm, Austria’s official State Award for Corporate Films, conducted biennially in partnership with the Austrian Ministry for Digital and Economic Affairs. His expertise spans awards management, jury coordination, and film curation. Beyond his professional pursuits, Alexander is an avid golfer and passionate world traveler."
    },
    images: [
      {
        src: "/images/kammelphotos/1.jpg",
        alt: "Alexander V. Kammel at speaking event"
      },
      {
        src: "/images/kammelphotos/2.jpg", 
        alt: "Alexander V. Kammel portrait"
      },
      {
        src: "/images/kammelphotos/3.jpg",
        alt: "Alexander V. Kammel at awards ceremony"
      }
    ],
    backgroundImage: {
      src: "https://placehold.co/1920x800/1597D6/FFFFFF?text=Alexander+Kammel+Background",
      alt: "Alexander V. Kammel Biography Background"
    }
  },

  // Film + Video Magazine Page Configuration
  filmVideoMagazine: {
    title: {
      lines: [
        { text: "FILM + VIDEO MAGAZINE", speed: 5 }
      ]
    },
    team: {
      title: "THE TEAM",
      publisher: {
        title: "PUBLISHER",
        name: "KR Alexander V. Kammel"
      },
      chiefEditor: {
        title: "CHIEF EDITOR", 
        name: "Nina Strasser"
      },
      editorialTeam: {
        title: "EDITORIAL TEAM",
        members: [
          "Hugo Marcos",
          "Carolina Fontana", 
          "Marlene Marcher"
        ]
      }
    },
    magazine: {
      title: "MAGAZINE",
      subtitle: "READ ON",
      covers: [
        {
          image: {
            src: "/images/logos/Cannes_Logo.png",
            alt: "Cannes Corporate Media & TV Awards Magazine Cover"
          },
          blogUrl: "https://www.cannescorporate.com/blog/en",
          hashtags: [
            "#corporate",
            "#video",
            "#interviews"
          ]
        },
        {
          image: {
            src: "/images/logos/CIFFT.png", 
            alt: "CIFFT Magazine Cover"
          },
          blogUrl: "https://www.cifft.com/blog?value=all",
          hashtags: [
            "#tourism",
            "#video",
            "#marketing"
          ]
        },
        {
          image: {
            src: "/images/logos/US_Logo.png",
            alt: "International Awards Magazine Cover"
          },
          blogUrl: "https://www.usinternationalawards.com/press?value=all",
          hashtags: [
            "#brandedcontent",
            "#video",
            "#onlinemedia"
          ]
        }
      ]
    }
  },

  // Filmservice History Page Configuration
  filmserviceHistory: {
    title: {
      lines: [
        { text: "FILMSERVICE", speed: 5 },
        { text: "HISTORY", speed: 10 }
      ]
    },
    subtitle: "AWARDS HAVE ALWAYS PLAYED A SIGNIFICANT ROLE IN MY LIFE",
    timeline: [
      {
        year: "1962",
        content: "I remember the wall behind my father's desk full of wonderful diplomas. Awards won by our films, mainly in Italy. Back then we were Austria's biggest film production company for Corporate Films and Commercials. Or my first festival film I watched in Venice in this huge film palace. A film with the thematics of the hare and the tortoise, a film by Pirelli, I think. I must have been about 5 years old.",
        image: {
          src: "/images/timelinephotos/1.jpg",
          alt: "Alexander V. Kammel portrait"
        }
      },
      {
        year: "1977",
        content: "A highlight was our annual trips to the International Industrial Film Congresses (festivals) every September, which took place every year in a different country around the world. We therefore organized Austria's participation. And we organized that festival in Vienna twice in 1977 and 1987. We had already co-founded the biannual German-speaking \"corporate filmdays\" in 1962, organized by the Austrian Chamber of Commerce. Filmservice took over the organization in 1982, '84 and '86. Since 2004 this festival, named \"Internationale Wirtschaftsfilmtage\", has been managed by Filmservice.",
        image: {
          src: "/images/timelinephotos/2.jpg",
          alt: "International Industrial Film Congress 1977"
        }
      },
      {
        year: ["1980", "1989"],
        content: "By then we had already founded Filmservice, which became the nation's biggest independent non-commercial film distributor, organizing millions of viewers for corporate films in Austria, then expanding to Germany and after the fall of the Iron Curtain even to Russia. Our intention was to find new clients by organizing awards. This is why we founded the International Tourism Film Festival in Vienna in 1980 which later became the \"Festival of Festivals\" leading in 1989 to the birthplace of the \"International Committee of Tourism Film Festivals CIFFT\", forming the unique and most important worldwide circuit for tourism films.",
        image: {
          src: "/images/timelinephotos/3.jpg",
          alt: "International Tourism Film Festival 1980"
        }
      },
      {
        year: "1998",
        content: "Further we founded \"AutoVision Awards\" in Munich, a festival dedicated to the Automotive Industry in the first step, which soon became a highlight at the IAA Auto Salon in Frankfurt. Now the festival celebrates its 30 years´ anniversary, opened up for the mobility industry and takes place at the IAA in Munich.",
        image: {
          src: "/images/timelinephotos/4.jpg",
          alt: "AutoVision Awards ceremony"
        }
      },
      {
        year: ["2010", "2021"],
        content: "With the change in technology, the distribution business disappeared, and what was once a side business became a full-time job: organizing awards. And with the creation of the Cannes Corporate Media & TV Awards in 2010, we brought back the glitz to the world of corporate films at a unique prestigious location: Cannes, France.\n\nWe continued our mission to be \"the home of corporate film festivals\" when we took over the then-recently shut-down memorable US International Film & Video Festival in 2021. We certainly did not want to see such a history-rich awards being brought to the grave, so with our expertise, we revised it and re-branded the competition into the US International Awards.",
        image: {
          src: "/images/timelinephotos/5.jpg",
          alt: "Los Angeles skyline with palm trees"
        }
      },
              {
          year: "2022",
          content: "In 2022, we took the CIFFT \"Festival of Festivals\" to a new level, renaming it the World Tourism Film Awards and holding the event for the first time outside of Vienna. The iconic city of Valencia (Spain) was the first destination to host the event. With its unique blend of professional networking, cultural immersion, and recognition of excellence, the World Tourism Film Awards has emerged as the ultimate reference point for tourism promotion through video.",
          image: {
            src: "/images/timelinephotos/6.jpg",
            alt: "World Tourism Film Awards ceremony"
          }
        },
        {
          year: "TODAY",
          content: "We are specialists in corporate awards organization, with many festivals of our own and helping other festivals thanks to our nearly 60 years of knowledge.",
          image: {
            src: "/images/timelinephotos/7.jpg",
            alt: "Award ceremony venue"
          }
        }
      ],
      finalSection: {
        content: {
          callToAction: "Turn your dream of winning an award for your outstanding films into reality – submit your work to one of our events, or simply send us your films and our specialists will guide you on the best competitions to enter.",
          teamMessage: "Our dedicated team would be happy to help you.",
          closing: "See you at one of our award ceremonies.",
          signature: {
            name: "Alexander V. Kammel",
            title: "President and Owner of Filmservice International"
          }
        }
      }
  },

  // Nominate a Jury Page Configuration
  nominateJury: {
    title: {
      lines: [
        { text: "NOMINATE A JUROR", speed: 5 }
      ]
    },
    content: {
      description: "Filmservice International is expanding its network of jury members and welcomes experienced professionals in film, media, marketing, and communication to join its international panels.\n\nEach nomination is reviewed with care to ensure a balanced and diverse panel of experts representing the highest standards of creativity and craft. Jury members may submit their own work to the festivals, but will never evaluate projects in which they or their company have been involved.\n\nIf you share a passion for creative excellence and would like to be considered for the Filmservice International jury panels, please complete the nomination form below."
    },
    form: {
      fields: {
        personalInfo: [
          {
            id: "fullName",
            label: "Full Name",
            type: "text",
            required: true,
            placeholder: "",
            fullWidth: true
          },
          {
            id: "title",
            label: "Title/Position",
            type: "text",
            required: true,
            placeholder: "",
            halfWidth: true
          },
          {
            id: "companyName",
            label: "Company Name",
            type: "text",
            required: true,
            placeholder: "",
            halfWidth: true
          },
          {
            id: "city",
            label: "City",
            type: "text",
            required: true,
            placeholder: "",
            halfWidth: true
          },
          {
            id: "country",
            label: "Country",
            type: "text",
            required: true,
            placeholder: "",
            halfWidth: true
          },
          {
            id: "mobile",
            label: "Mobile",
            type: "tel",
            required: true,
            placeholder: "",
            halfWidth: true
          },
          {
            id: "email",
            label: "Email",
            type: "email",
            required: true,
            placeholder: "",
            halfWidth: true
          }
        ],
        bio: {
          id: "shortBio",
          label: "Short Bio/Info:",
          type: "textarea",
          required: true,
          placeholder: ""
        },
        expertise: {
          title: "Best qualified to judge:",
          options: [
            {
              id: "corporateVideos",
              label: "Corporate Videos",
              defaultChecked: false
            },
            {
              id: "documentaries",
              label: "Documentaries & Reports",
              defaultChecked: false
            },
            {
              id: "onlineSocialMedia",
              label: "Online & Social Media Videos",
              defaultChecked: false
            },
            {
              id: "tourismVideos",
              label: "Tourism Videos",
              defaultChecked: false
            },
            {
              id: "studentVideos",
              label: "Student Videos",
              defaultChecked: false
            },
            {
              id: "independentVideos",
              label: "Independent Videos",
              defaultChecked: false
            },
            {
              id: "productionArt",
              label: "Production Arts & Crafts",
              defaultChecked: false
            }
          ]
        },
        socialMedia: [
          {
            id: "facebook",
            label: "facebook.com/",
            placeholder: "Facebook Handle",
            type: "text",
            required: false
          },
          {
            id: "instagram",
            label: "instagram.com/",
            placeholder: "Instagram Handle",
            type: "text",
            required: false
          },
          {
            id: "linkedin",
            label: "linkedin.com/",
            placeholder: "LinkedIn Handle",
            type: "text",
            required: false
          }
        ]
      },
      submitButton: {
        text: "Submit"
      },
      countries: [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia",
        "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus",
        "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil",
        "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada",
        "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica",
        "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
        "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
        "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana",
        "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
        "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
        "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North",
        "Korea, South", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho",
        "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia",
        "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
        "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia",
        "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia",
        "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay",
        "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
        "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
        "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore",
        "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka",
        "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",
        "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan",
        "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay",
        "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
      ]
    }
  },

  // Österreichisches Filmservice Page Configuration
  osterreichischesFilmservice: {
    title: {
      lines: [
        { text: "ÖSTERREICHISCHES", speed: 5 },
        { text: "FILMSERVICE", speed: 10 }
      ]
    },
    contact: {
      description: "THE AUSTRIAN FILM SERVICE DISTRIBUTES EDUCATIONAL AND INFORMATIONAL FILMS FOR SELECTED CUSTOMERS",
      title: "CONTACT",
      name: "KR ALEXANDER V. KAMMEL",
      email: {
        display: "akammel(at)filmservice.at",
        link: "mailto:akammel@filmservice.at",
        icon: "fas fa-envelope"
      }
    },
    map: {
      image: {
        src: "/images/map.png",
        alt: "Austrian Film Service Location Map"
      },
      googleMapsUrl: "https://maps.app.goo.gl/y8c44hzBPAh6mu3c6"
    }
  },

  // Festivals Section Configuration
  festivals: {
    title: "Featured Festivals",
    showTitle: false, // Hide title for clean design
    opacity: 0.6, // Global opacity for all festival backgrounds (0.0 to 1.0)
    items: [
      {
        name: "Cannes Corporate Media & TV Awards",
        logo: {
          src: "/images/logos/Cannes_Logo.png",
          alt: "Cannes Corporate Media & TV Awards"
        },
        backgroundImage: {
          src: "/images/throphy/Cannes-Corporate.jpg",
          alt: "Cannes Corporate Media & TV Awards"
        },
        title: "CANNES CORPORATE MEDIA & TV AWARDS",
        description: "The Cannes Corporate Media & TV Awards annually honour the world's finest corporate films, online media productions, and documentaries and reports in one of the most important film centres of the world: in Cannes, France.",
        buttonText: "Visit Website",
        url: "https://www.cannescorporate.com/",
        backgroundColor: "#B59C57"
      },
      {
        name: "International Awards Los Angeles",
        logo: {
          src: "/images/logos/US_Logo.png",
          alt: "International Awards Los Angeles"  
        },
        backgroundImage: {
          src: "/images/throphy/Us-International.jpg",
          alt: "International Awards Los Angeles"
        },
        title: "US INTERNATIONAL AWARDS",
        description: "The global competition is open for Corporate Videos, Online & Social Media Videos, Documentaries & Reports, Independent Videos, and Student Videos. Formerly known as US International Film & Video Festival, the awards have a background of more than 50 years.",
        buttonText: "Visit Website",
        url: "https://www.usinternationalawards.com/",
        backgroundColor: "#170E49"
      },
      {
        name: "Wirtschaftsfilmtage",
        logo: {
          src: "/images/logos/WFT.png",
          alt: "Wirtschaftsfilmtage"
        },
        backgroundImage: {
          src: "/images/throphy/Wirtschaftsfilmtage.jpg",
          alt: "Wirtschaftsfilmtage Background"
        },
        title: "INTERNATIONALE WIRTSCHAFTSFILMTAGE",
        description: "The award is the oldest and largest competition for corporate film productions in the German-speaking world. It biennially honours the best productions from Austria, Germany, Switzerland, Luxembourg, Liechtenstein, and South Tyrol with the renowned Victoria Awards.",
        buttonText: "Visit Website",
        url: "https://www.wirtschaftsfilmtage.com/",
        backgroundColor: "#AECA37"
      },
      {
        name: "Staatspreis Wirtschaftsfilm",
        logo: {
          src: "/images/logos/Staatspreis_Wirtschaftsfilm.png",
          alt: "Staatspreis Wirtschaftsfilm"
        },
        backgroundImage: {
          src: "/images/throphy/Staatspreis.jpg",
          alt: "Staatspreis Wirtschaftsfilm"
        },
        title: "STAATSPREIS WIRTSCHAFTSFILM",
        description: "Is the Austrian State Prize for corporate videos on the initiative of the Federal Ministry of Economy, Energy and Tourism.",
        buttonText: "Visit Website", 
        url: "https://www.staatspreisfilm.at/",
        backgroundColor: "#CD0237"
      },
      {
        name: "CIFFT Festival",
        logo: {
          src: "/images/logos/CIFFT.png",
          alt: "CIFFT International Festival"
        },
        backgroundImage: {
          src: "/images/throphy/CIFFT.jpg",
          alt: "CIFFT International Festival"
        },
        title: "CIFFT CIRCUIT",
        description: "An outstanding competition covering international and corporate film awards to reward the world's best tourism videos, ads, and campaigns of the world.",
        buttonText: "Visit Website",
        url: "https://www.cifft.com/",
        backgroundColor: "#AEC8DE"
      }
    ]
  },

  // Imprint Page Configuration
  imprint: {
    title: {
      lines: [
        { text: "IMPRINT", speed: 5 }
      ]
    },
    legalInformation: {
      company: {
        name: "Filmservice International",
        address: {
          street: "Schaumburgergasse 18,",
          city: "1040 Vienna",
          country: "AUSTRIA"
        }
      },
      dutyText: {
        text: "Duty of information according to section 5 paragraph 1 Austrian E-Commerce law",
        url: "https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=75a3ffca-2c2b-46c4-887c-ed31deacb9a1"
      },
      mediaOwner: {
        title: "Media Owner:",
        name: "Kammel Österreichisches Filmservice e.U.",
        address: "Schaumburgergasse 18, 1040 Vienna, Austria",
        registration: {
          commercialRegister: "Commercial register no.: 499113 s (Commercial court-Vienna)",
          vatId: "VAT ID No.: ATU 73692104"
        },
        email: {
          display: "info(AT)filmserviceinternational.com",
          link: "mailto:info@filmserviceinternational.com"
        },
        additionalInfo: {
          text: "Kammel Österreichisches Film - Service e.U. | WKO Firmen A-Z",
          url: "https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=75a3ffca-2c2b-46c4-887c-ed31deacb9a1"
        }
      }
    }
  },

  // Footer Configuration
  footer: {
    contactScrolling: {
      text: "CONTACT US",
      speed: 30,
      direction: "left"
    },
    partnerLogos: [
      {
        src: "/images/logos/logo_partners/1.png",
        alt: "Partner Organization 1",
        url: ""
      },
      {
        src: "/images/logos/logo_partners/2.png", 
        alt: "Partner Organization 2",
        url: ""
      },
      {
        src: "/images/logos/logo_partners/3.png",
        alt: "Partner Organization 3", 
        url: ""
      },
      {
        src: "/images/logos/logo_partners/4.png",
        alt: "Partner Organization 4",
        url: ""
      },
      {
        src: "/images/logos/logo_partners/5.png",
        alt: "Partner Organization 5",
        url: ""
      }
    ],
    copyright: {
      year: "2025",
      company: "Filmservice International",
      text: "All Rights Reserved"
    },
    poweredBy: {
      text: "Powered by",
      company: "Pragmática",
      url: "https://pragmatica.pt"
    },
    legalLinks: [
      { name: "Data Policy", url: "/data-policy" },
      { name: "Imprint", url: "/imprint" }
    ]
  },

  // SEO & Meta
  seo: {
    title: "Filmservice International - Home of Corporate Film Festivals",
    description: "Leading platform for corporate film festivals, connecting filmmakers with businesses worldwide.",
    keywords: "film festivals, corporate films, filmmaking, video production, business storytelling"
  }
};

export default siteConfig; 